module.exports = __webpack_public_path__ + "img/logo-Bangkok-Bank.6552f1f.png";